/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  UserSessionIssuerCimdClient,
  UserSessionIssuerCimdClient$inboundSchema,
} from "./usersessionissuercimdclient.js";

/**
 * Result type for listing an issuer's custom CIMD document URLs.
 */
export type ListUserSessionIssuerCimdClientsResult = {
  items: Array<UserSessionIssuerCimdClient>;
  /**
   * Cursor for the next page; empty when exhausted.
   */
  nextCursor?: string | undefined;
};

/** @internal */
export const ListUserSessionIssuerCimdClientsResult$inboundSchema:
  z.ZodMiniType<ListUserSessionIssuerCimdClientsResult, unknown> = z.pipe(
    z.object({
      items: z.array(UserSessionIssuerCimdClient$inboundSchema),
      next_cursor: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        "next_cursor": "nextCursor",
      });
    }),
  );

export function listUserSessionIssuerCimdClientsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListUserSessionIssuerCimdClientsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      ListUserSessionIssuerCimdClientsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListUserSessionIssuerCimdClientsResult' from JSON`,
  );
}
